import React from "react";
import dreaMed from "../assets/med-images/dream.png";
import roche from "../assets/med-images/Roche.png";
import medronic from "../assets/med-images/Medronic.png";

export default function DreaMed() {
  return (
    <div>
      <div className="flex justify-center lg:gap-5 gap-2">
        <div className="lg:max-w-[300px] flex items-center"><img src={dreaMed} alt="gluco" className=" " /></div>
        <div className="lg:max-w-[300px] flex items-center"><img src={roche} alt="gluco" className="" /></div>
        <div className="lg:max-w-[300px] flex items-center"><img src={medronic} alt="gluco" className="" /></div>
      </div>
      <div className="mx-auto max-w-6xl py-8 px-4 lg:px-28 text-center">
        <p>
        Navedene informacije niso zdravstveni nasvet in ne nadomeščajo pogovora z vašim zdravnikom. Glede indikacij, kontraindikacij, opozoril, previdnostnih ukrepov, možnih neželenih dogodkov in vseh drugih informacij se posvetujte z zdravstvenim delavcem. Za celoten seznam koristi, indikacij, previdnostnih ukrepov, kliničnih rezultatov in drugih pomembnih zdravstvenih informacij, povezanih z obravnavano terapijo ali izdelki, se posvetujte z zdravstvenim strokovnjakom. Za podrobne informacije o navodilih za uporabo, indikacijah, kontraindikacijah, opozorilih, previdnostnih ukrepih in možnih neželenih dogodkih si oglejte priročnike za napravo. Za dodatne informacije se obrnite na lokalnega predstavnika podjetja Medtronic.
        </p>
        <br />
        <p>
        EMEA-CGM-2400037© Medtronic 2024. Vse pravice pridržane. Medtronic, Medtronic logo in Engineering the extraordinary so blagovne znamke družbe Medtronic.™* Blagovne znamke tretjih oseb so last njihovih lastnikov. Vse druge blagovne znamke so last družbe Medtronic.
DreaMed Diabetes je blagovna znamka DreaMed Diabetes, Ltd. Algoritem sistema MiniMed™ 780G vključuje tehnologijo, ki jo je razvil DreaMed Diabetes.

        </p>
      </div>
    </div>
  );
}
